import React from 'react';
import PropTypes from 'prop-types';
import { Chip as MuiChip, Typography } from '@mui/material';

const Chip = React.forwardRef(
  ({ label, typographyComponent = 'span', ...props }: any, ref: any) => {
    return (
      <MuiChip
        ref={ref}
        label={
          <Typography variant="body2" component={typographyComponent} sx={{ fontWeight: '600' }}>
            {label}
          </Typography>
        }
        {...props}
      />
    );
  },
);

Chip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  typographyComponent: PropTypes.string,
};

Chip.displayName = 'Chip';

export default Chip;
